angular.module('cvsApp').service('scheduleOrderService', ['networkService', 'xdrService', 'scheduleOrderModel', 'configManager', 'cvsAppData', 'itemCartModel', function (NS, XS, SOM, CM, CAD, ICM) {

    function scheduleOrderService() {
        this.scheduleOrder = function (callBackSuccess) {
            //get url
            var tokenId, tokenType;
            /*var tokenId=CAD.getTokenId();
            var tokenType=CAD.getTokenType();*/
            try {
                tokenId = CAD.getTokenId() ? CAD.getTokenId() : (guestTokenID || cvsUtility.queryMap.tokenId);
                tokenType = CAD.getTokenType() ? CAD.getTokenType() : ((guestTokenID) ? 'Guest' : 'Login');
            } catch (ex) {
                tokenId = guestTokenID || cvsUtility.queryMap.tokenId;
                tokenType = (guestTokenID) ? 'Guest' : 'Login';
            }
            var url = CM.getAGPAPIUrl('AGP_SCHEDULE_ORDER');
            var request = {
                url: url,
                header: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                data: getRequestBody(tokenId, tokenType),
                onSuccess: callBackSuccess
            }
            cvsUtility.commonServiceCode(url, "scheduleOrder", SOM, request, callBackSuccess, NS);

        }

        var getRequestBody = function (tokenId, tokenType) {
            var apikey = CAD.hasOwnProperty('getApiKey') ? CAD.getApiKey() : cvsUtility.queryMap.apikey;
            var scheduleOrderInfoArray = [];
            var cartDrugs = ICM.getCartItems();
            if (ICM.checkOutInfo('pickOrDel') == 'pickup') {
                var address = ICM.checkOutInfo('storeCheckOutInfo');
                var shippingAddressInfo = {
                    'addressLine1': address.storeAddress.addressLine1,
                    'addressLine2': address.storeAddress.addressLine2,
                    'city': address.storeAddress.city,
                    'state': address.storeAddress.state,
                    'zipCode': address.storeAddress.zipCode,
                    'storeNumber' : address.storeNumber
                }
            } else {
                var address = ICM.checkOutInfo('OrderConfirmationAddress');
                var shippingAddressInfo = {
                    'addressIdEnc': address.addressIdEnc,
                    'addressIdHash': address.addressIdHash,
                    'addressLine1': address.addressLine1,
                    'addressLine1Enc': address.addressLine1Enc,
                    'addressLine2': address.addressLine2,
                    'addressLine2Enc': address.addressLine2Enc,
                    'city': address.city,
                    'cityEnc': address.cityEnc,
                    'state': address.state,
                    'zipCode': address.zipCode,
                    'zipCodeEnc': address.zipCodeEnc,
                }
            }
            for (var i = 0; i < cartDrugs.length; i++) {
                var obj = {};
                obj.rxNumber = cartDrugs[i].rxNumber;
                obj.rxNumberEnc = cartDrugs[i].rxNumberEnc;
                obj.rxNumberHash = cartDrugs[i].rxNumberHash;
                obj.firstFillIndicator = cartDrugs[i].firstFillIndicator;
                obj.refillNumber = cartDrugs[i].currentFillNumber.toString();
                obj.dispensingStoreNumber = cartDrugs[i].dispensingStoreDetails.dispensingStoreNumber;
                obj.daysSupply = cartDrugs[i].daysSupply.toString();
                obj.refrigIndicator = cartDrugs[i].refrigIndicator;
                obj.prescriptionSystemName = cartDrugs[i].prescriptionSystemName;
                obj.shippingAddress = shippingAddressInfo;
                if (cartDrugs[i].suppliesGrouped) {
                    var supplyObjArray = [];
                    for (var j = 0; j < cartDrugs[i].suppliesGrouped.length; j++) {
                        var groupObj = {};
                        groupObj.rxNumber = cartDrugs[i].suppliesGrouped[j].rxNumber;
                        groupObj.rxNumberEnc = cartDrugs[i].suppliesGrouped[j].rxNumberEnc;
                        groupObj.rxNumberHash = cartDrugs[i].suppliesGrouped[j].rxNumberHash;
                        groupObj.firstFillIndicator = cartDrugs[i].suppliesGrouped[j].firstFillIndicator;
                        groupObj.refillNumber = cartDrugs[i].suppliesGrouped[j].currentFillNumber.toString();
                        groupObj.dispensingStoreNumber = cartDrugs[i].suppliesGrouped[j].dispensingStoreDetails.dispensingStoreNumber;
                        groupObj.daysSupply = cartDrugs[i].suppliesGrouped[j].daysSupply.toString();
                        groupObj.refrigIndicator = cartDrugs[i].suppliesGrouped[j].refrigIndicator;
                        groupObj.prescriptionSystemName = cartDrugs[i].suppliesGrouped[j].prescriptionSystemName;
                        supplyObjArray.push(groupObj);
                    }
                    obj.supplies = supplyObjArray;
                }
                scheduleOrderInfoArray.push(obj);
            }

            var reqObj = {
                "scheduleOrderRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "lineOfBusiness": "Specialty",
                            "channelName": cvsUtility.queryMap.channel,
                            "responseFormat": "JSON",
                            "tokenID": tokenId,
                            "tokenType": CM.getAGPTokenType(tokenType)

                        },
                        "securityContext": {
                            "apiKey": apikey,
                            "securityType": "apiKey"
                        }
                    },
                    "details": {
                        "rxDetails": scheduleOrderInfoArray
                    }
                }
            };

            return reqObj;
        }
    }

    return new scheduleOrderService();
}]);
